import { call, put, flush, delay, takeEvery } from "redux-saga/effects";
import { SagaIterator } from "redux-saga";

import { INIT_REQUEST_BITHUMB, INIT_SUCCESS_BITHUMB, RECEIVE } from '../modules/bithumb';

import { bithumbTicker, BithumbTickerPacket } from '../../utils/parser';
import { createSocket, connectSocekt } from '../../utils/common';
import { arrToObj, latestTicker } from '../../utils/array';

import { CoinCommon } from '../../types';

function* init({ payload }: any): SagaIterator {
  try {
    const coins: string[] = payload.map((item: { name: string }) => item.name)
    if (!coins.length) return

    yield put({
      type: INIT_SUCCESS_BITHUMB,
      payload: {
        data: coins,
        m: arrToObj(coins)
      }
    })
    const client = yield call(createSocket, "wss://pubwss.bithumb.com/pub/ws");
    const clientChannel = yield call(
      connectSocekt,
      client,
      JSON.stringify({
        type: "ticker",
        symbols: coins,
        tickTypes: ["30M"]
      }),
      (evt: any) => {
        const data = JSON.parse(evt.data);
        return [
          data.type === "ticker",
          data.content
        ]
      }
    )

    while (true) {
      const datas: BithumbTickerPacket[] = yield flush(clientChannel); // 버퍼 데이터 가져오기

      if (datas.length) {
        const sortedData: CoinCommon[] = latestTicker<BithumbTickerPacket>(datas, bithumbTicker);

        yield put({
          type: RECEIVE,
          payload: {
            data: sortedData,
          }
        })
      }

      yield delay(100);
    }
  } catch (err) {
    console.log('[SAGA] getUserInfo API error');
    console.log(err)
  }

}

function* bithumbSaga(): SagaIterator {
  yield takeEvery(INIT_REQUEST_BITHUMB, init);
  // yield takeEvery(WORKSITE_INIT_REQUEST, workSiteInit);
}

export default bithumbSaga;